<app-nav-top-bar #navtopbar (showMenuEmitter)="onShowMenu($event)"></app-nav-top-bar>

<mat-sidenav-container class="principal-container" autosize="true">
    <mat-sidenav class="menu-sidenav" mode="side" opened="true" [disableClose]="true">
        @if (showNav) {
        <app-nav-menu [isExpanded]="showMenu"></app-nav-menu>
        }
    </mat-sidenav>

    <div class="principal-sidenav-content">
        <router-outlet></router-outlet>
    </div>
</mat-sidenav-container>
<ngx-spinner class="spinner" bdColor="rgba(0, 0, 0, 0.8)" size="large" color="var(--primary-color)" type="timer" [fullScreen]="true"></ngx-spinner>
